import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { environment } from '@env/environment.local';
import { AuthService } from '../common/auth.service';
import { Permission } from '../models/permissions.enum';
import { PermissionService } from '../services/permission-manager.service';
import { generalAreas } from './models/generalAreas.model';
import { NotificationService } from '../services/notifications.service';
import { BaseComponent } from '../components/base/base.component';
import { LoginService } from '@app/pages/login/services/login.service';
import { SessionStorageService } from '@app/services/session-storage.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  readonly authService = inject(AuthService);
  private readonly LAST_REFRESH_KEY = 'lastRefreshTokenTime';
  private readonly MIN_REFRESH_INTERVAL = 10 * 60 * 1000;

  content?: string;
  isLoading!: boolean;
  dealerSite = environment.DEALERS_SITE;
  permissions = Permission;

  generalAreas: generalAreas[] = [
    {
      label:'Portal de Clientes',
      href: 'https://www.daimlerfinancialservices.com.mx',
      image:'portal_de_clientes',
      permissions: [Permission.administracion0]
    },
    {
      label:'Campañas Marketing',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=videoCampaign0`,
      image:'campanas_mkt',
      permissions: [Permission.videoCampaign0]
    },
    {
      label:'E-files Autos',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=efilesAutosAnalistas1`,
      image:'e-files_autos',
      permissions: [Permission.efilesAutos0]
    },
    /*{
      label:'Propuesta de valor',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=circulares0`,
      image:'propuesta_de_valor',
      permissions: [Permission.propuestaValor0]
    },*/
    {
      label:'Circulares',
      href: '/mailshot/admin-mailshot',
      image: 'circulares',
      target: '_self',
      permissions: [Permission.circulares0],
    },
  ];

  moreAccesses: generalAreas[] = [
    {
      label:'Mercedes-Benz Insurance',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=seguros0`,
      image:'insurance',
      permissions: [Permission.seguros0]
    },
    {
      label:'Dealer contact center',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=dealercontact0`,
      image:'',
      permissions: [Permission.dealercontact0]
    },
    {
      label:'PBL',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=pbl0`,
      image:'pbl',
      permissions: [Permission.pbl0]
    },
    {
      label:'Descargas',
      href: `/downloads`,
      image: '',
      permissions: [Permission.descargas0],
    },
    {
      label:'Directorio',
      href: `/info/directory`,
      image:'directorio',
      permissions: [Permission.directorio0]
    },
    {
      label:'Loan to value',
      href: `${this.dealerSite}token=${this.authService.tokenLS}&pagina=ltv`,
      image:'',
      permissions: [Permission.ltv]
    },
  ];
  private readonly loginService = inject(LoginService);
  private readonly sessionStorageService = inject(SessionStorageService);
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private permissionService: PermissionService,
    private notificationsService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.initializeAreas();
    this.initializeMoreAccesses();
    // this.refreshToken();
  }

  refreshToken(){
    // Validar si han pasado al menos 10 minutos desde el último refresh exitoso
    const lastRefreshTime = this.sessionStorageService.getItem(this.LAST_REFRESH_KEY);
    const currentTime = Date.now();

    if (lastRefreshTime) {
      const timeSinceLastRefresh = currentTime - parseInt(lastRefreshTime, 10);
      if (timeSinceLastRefresh < this.MIN_REFRESH_INTERVAL) {
        return;
      }
    }

    const token = this.sessionStorageService.getItem(
      environment.REFRESH_TOKEN
    );
    const setHeaders = {
      Authorization: `Bearer ${token}`,
    };
    this.loginService.refreshToken(setHeaders).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) => {
        this.sessionStorageService.setItem(environment.TOKEN, data.data.jwt);
        this.sessionStorageService.setItem(
          environment.REFRESH_TOKEN,
          data.data.refreshToken
        );
        this.authService.tokenLS = data.data.jwt;
        this.sessionStorageService.setItem(this.LAST_REFRESH_KEY, currentTime.toString());
      },
      error: (error) => {
        const errorMessage = error?.error?.[0] ?? error?.message ?? error ?? "";
        if(errorMessage.includes("Query did not return a unique result: 2") || errorMessage.includes("no found token")) {
          this.authService.logout();
          this.notificationsService.showMessage(["Hemos detectado un problema con tu sesión. Por favor, vuelve a iniciar sesión."], 'error');
         }
      }
    });
  }

  initializeAreas(){
    let hasPermission: generalAreas[] = [];

    this.generalAreas.map((i)=>{
      if(this.permissionService.validatePermissionKey(i.permissions)){
        hasPermission.push(i);
      }
    });
    this.generalAreas = hasPermission;
  }

  initializeMoreAccesses(){
    let hasPermission: generalAreas[] = []
    this.moreAccesses.map((i)=>{
      if(this.permissionService.validatePermissionKey(i.permissions)){
         hasPermission.push(i);
      }
    });
    this.moreAccesses = hasPermission;
  }

}
